import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { LocationIcon } from '../../Icons/LocationIcon';
import { HOTEL_MAP_ELEM_ID } from '../../../../consts/selectors';
import { ComponentJSSClasses } from './styles';


export interface HotelLocationProps {
    countryName: string | null;
    resortName: string | null;
}

export interface StyledHotelLocationProps extends HotelLocationProps, JSSClassesProps<ComponentJSSClasses> { }

export function HotelLocation(props: StyledHotelLocationProps) {
    const { classes } = props;

    if (!props.countryName && !props.resortName) {
        return null;
    }

    const renderResort = () => (
        <a
            href={`#${HOTEL_MAP_ELEM_ID}`}
            className={classes.link}
            data-qa-node={"Title-ResortName"}
        >
            {props.resortName}
        </a>
    );

    const renderCountry = () => (
        <a
            href={`#${HOTEL_MAP_ELEM_ID}`}
            className={classes.link}
            data-qa-node={"Title-CountryName"}
        >
            {props.countryName}
        </a>
    );
       
    return (
        <>
            <span className={classes.icon}>
                <LocationIcon />
            </span>
            {props.resortName && renderResort()}
            {props.resortName && props.countryName &&
                <span className={classes.comma}>, </span>}
            {props.countryName && renderCountry()}
        </>
    );
}

export default HotelLocation;
